import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { useAppDispatch } from '../../redux/hooks';
import { fetchFeeAccounts } from '../../redux/modules/feeAccount/feeAccount.actions';
import { Ledger } from '../../components/RefactoredLedger';
import { useFetchLedgerQuery } from '../../redux/features/ledger/refactoredLedger.apiSlice';

const FeeTable = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchFeeAccounts());
  }, []);

  return (
    <Grid item container flexDirection="column" component={Paper} sx={{ p: '24px', mt: '24px' }} spacing={2}>
      <Typography variant="h6">Cash Ledger</Typography>
      <Ledger accountId={1} fetchLedger={useFetchLedgerQuery} type="cash" memo="Fee Collection" hideFilter />
    </Grid>
  );
};

export default FeeTable;
